import React from 'react';
import { TranscriptContext } from './TranscriptContainer';

/**
 * connectToPlayer
 * @param Component
 * @returns {React.Component}
 */
export const connectToTranscript = Component => function TranscriptComponent(props) {
  return (
    <TranscriptContext.Consumer>
      {(state) => {
        const newProps = { ...state, ...props };
        return (<Component {...newProps} transcriptContext={state} />);
      }}
    </TranscriptContext.Consumer>
  );
};

export default connectToTranscript;
